import { useQuery } from "@tanstack/react-query";
import alarmParametersService from "../../../../services/web/alarm-parameters-service";

const fetchAlarmParameters = async () => {
    const data = await alarmParametersService.list();

    const findValue = (key) => data.find((item) => item.key === key)?.value ?? null;

    const delayed = findValue("sentry.api.fact.minutestoautomaticsign");
    const confidence = findValue("sentry.event.minconfidence");
    const expire = findValue("user.auto.assign.alarm.plus.days");
    const sign2 = findValue("sentry.alarms.sign2.enabled");

    return {
        delayedMinutes: delayed !== null ? Number(delayed) : 0,
        confidenceIndex: confidence !== null ? Number(confidence) : 0,
        expireDays: expire !== null ? Number(expire) : 0,
        sign2Auto: sign2 !== null ? String(sign2) : "false",
    };
};

export const useAlarmParametersQuery = () => {
    return useQuery({
        queryKey: ["alarmParameters"],
        queryFn: fetchAlarmParameters,
    });
};